import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InteractionComponent} from './interaction/interaction.component';
import {TranslateModule} from '@ngx-translate/core';
import {ZoomComponent} from './zoom/zoom.component';
import {EmojisComponent} from './emojis/emojis.component';
import {CardComponent} from './card/card.component';
import {TalkjsComponent} from './talkjs/talkjs.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    CardComponent,
  ],
  declarations: [
    InteractionComponent,
    ZoomComponent,
    EmojisComponent,
    TalkjsComponent
  ],
  exports: [
    InteractionComponent,
    ZoomComponent,
    EmojisComponent,
    TalkjsComponent
  ]
})
export class ConferenceComponentsModule {
}
